module.exports = __webpack_public_path__ + "static/media/IMG_Icon.d30fb77c.svg";